/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MediaAPI {

  /**
   * Method that creates a media
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiMedia(
    requestBody: {
      id?: number;
      name?: string | null;
      content_type_id: number;
      media_type_id: number;
      format_id?: number | null;
      mime_type?: string | null;
      preview_image_path?: string | null;
      media?: string | null;
      headline?: string | null;
      display_url?: string | null;
      duration?: number | null;
      created_at?: string | null;
      is_replacement?: boolean;
      is_deleted?: boolean;
      is_secure?: boolean;
      owner_id?: number | null;
      agency_id?: number | null;
      platform_id?: number;
      filesize?: number | null;
      height?: number | null;
      width?: number | null;
      videooh_encoding_status?: 'encoding' | 'error' | 'done' | null;
      videooh_media?: string | null;
      is_draft?: boolean;
    },
  ): CancelablePromise<{
    id: number;
    name: string | null;
    content_type_id: number;
    media_type_id: number;
    format_id: number | null;
    mime_type: string | null;
    preview_image_path: string | null;
    media: string | null;
    headline: string | null;
    display_url: string | null;
    duration: number | null;
    created_at: string | null;
    is_replacement: boolean;
    is_deleted: boolean;
    is_secure: boolean;
    owner_id: number | null;
    agency_id: number | null;
    platform_id: number;
    filesize: number | null;
    height: number | null;
    width: number | null;
    videooh_encoding_status: 'encoding' | 'error' | 'done' | null;
    videooh_media: string | null;
    is_draft: boolean;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/media',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates a media
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiMedia(
    requestBody: {
      id: number;
      name?: string | null;
      content_type_id?: number;
      media_type_id?: number;
      format_id?: number | null;
      mime_type?: string | null;
      preview_image_path?: string | null;
      media?: string | null;
      headline?: string | null;
      display_url?: string | null;
      duration?: number | null;
      created_at?: string | null;
      is_replacement?: boolean;
      is_deleted?: boolean;
      is_secure?: boolean;
      owner_id?: number | null;
      agency_id?: number | null;
      platform_id?: number;
      filesize?: number | null;
      height?: number | null;
      width?: number | null;
      videooh_encoding_status?: 'encoding' | 'error' | 'done' | null;
      videooh_media?: string | null;
      is_draft?: boolean;
    },
  ): CancelablePromise<{
    id: number;
    name: string | null;
    content_type_id: number;
    media_type_id: number;
    format_id: number | null;
    mime_type: string | null;
    preview_image_path: string | null;
    media: string | null;
    headline: string | null;
    display_url: string | null;
    duration: number | null;
    created_at: string | null;
    is_replacement: boolean;
    is_deleted: boolean;
    is_secure: boolean;
    owner_id: number | null;
    agency_id: number | null;
    platform_id: number;
    filesize: number | null;
    height: number | null;
    width: number | null;
    videooh_encoding_status: 'encoding' | 'error' | 'done' | null;
    videooh_media: string | null;
    is_draft: boolean;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/media',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns a particular media
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiMedia(
    id: number,
  ): CancelablePromise<{
    id: number;
    name: string | null;
    content_type_id: number;
    media_type_id: number;
    format_id: number | null;
    mime_type: string | null;
    preview_image_path: string | null;
    media: string | null;
    headline: string | null;
    display_url: string | null;
    duration: number | null;
    created_at: string | null;
    is_replacement: boolean;
    is_deleted: boolean;
    is_secure: boolean;
    owner_id: number | null;
    agency_id: number | null;
    platform_id: number;
    filesize: number | null;
    height: number | null;
    width: number | null;
    videooh_encoding_status: 'encoding' | 'error' | 'done' | null;
    videooh_media: string | null;
    is_draft: boolean;
    preview_image_url?: string;
    media_attribute?: Array<{
      id?: number;
      media_id: number;
      type_id: number;
      value?: string | null;
      created_at?: string | null;
      url?: string;
      attribute_type?: {
        id?: number;
        content_type_id: number;
        value_type?: 'path' | 'string' | 'integer' | 'float' | 'boolean' | 'text' | null;
        name?: string;
        default_value?: string | null;
        mandatory?: boolean;
      };
    }>;
    media_creative?: Array<{
      id?: number;
      media_id: number;
      mime_type?: string | null;
      name?: string | null;
      path?: string | null;
      created_at?: string | null;
    }>;
    media_event?: Array<{
      id?: number;
      media_id: number;
      event_id: number;
      primary?: boolean;
      event_name?: string | null;
      url?: string | null;
      views?: number | null;
    }>;
    media_video?: Array<{
      id?: number;
      media_id: number;
      mime_type: string;
      file_path: string;
      duration?: number | null;
      width: number;
      height: number;
      bitrate?: number | null;
      filesize?: number | null;
      created_at?: string;
      url?: string;
    }>;
    campaign_media?: Array<{
      id?: number;
      campaign_id: number;
      media_id: number;
      parent_campaign_media_id?: number | null;
      is_companion?: boolean;
      approval_status_id?: 'active' | 'inactive' | 'pending' | 'refused';
      views?: number;
      clicks?: number;
      viewed_impressions?: number;
      refreshed_impressions?: number;
      undetermined_impressions?: number;
      created_at?: string;
      zone_id?: number | null;
      clickthrough_url?: string | null;
      start_date?: string | null;
      end_date?: string | null;
      max_impressions_ratio?: number;
      is_video_playing_out_of_view?: boolean;
      is_video_looping?: boolean;
      inline_pause_to_overlay?: boolean;
      refusal_notes?: string | null;
      campaign?: {
        id?: number;
        product?: string | null;
        created_at?: string;
        order?: {
          id?: number;
          label?: string | null;
          name?: string | null;
          internal_reference_number?: string | null;
        } | null;
      };
    }>;
    html5_files?: Array<{
      size?: string;
      lastModified?: string;
      name?: string;
    }>;
  } | null> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns a list of attributes for a media
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiMediaAttributeList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    media_id: number;
    type_id: number;
    value: string | null;
    created_at: string | null;
    attribute_type?: {
      id?: number;
      content_type_id: number;
      value_type?: 'path' | 'string' | 'integer' | 'float' | 'boolean' | 'text' | null;
      name?: string;
      default_value?: string | null;
      mandatory?: boolean;
    };
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{id}/attribute/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that update a media from uploaded file
   * @param id
   * @param formData
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiMediaFillUpload(
    id: number,
    formData: {
      file: Blob;
    },
  ): CancelablePromise<{
    id: number;
    name: string | null;
    content_type_id: number;
    media_type_id: number;
    format_id: number | null;
    mime_type: string | null;
    preview_image_path: string | null;
    media: string | null;
    headline: string | null;
    display_url: string | null;
    duration: number | null;
    created_at: string | null;
    is_replacement: boolean;
    is_deleted: boolean;
    is_secure: boolean;
    owner_id: number | null;
    agency_id: number | null;
    platform_id: number;
    filesize: number | null;
    height: number | null;
    width: number | null;
    videooh_encoding_status: 'encoding' | 'error' | 'done' | null;
    videooh_media: string | null;
    is_draft: boolean;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/media/{id}/fill/upload',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * Method that update a media from URL
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiMediaFillUrl(
    id: number,
    requestBody: {
      url: string;
    },
  ): CancelablePromise<{
    id: number;
    name: string | null;
    content_type_id: number;
    media_type_id: number;
    format_id: number | null;
    mime_type: string | null;
    preview_image_path: string | null;
    media: string | null;
    headline: string | null;
    display_url: string | null;
    duration: number | null;
    created_at: string | null;
    is_replacement: boolean;
    is_deleted: boolean;
    is_secure: boolean;
    owner_id: number | null;
    agency_id: number | null;
    platform_id: number;
    filesize: number | null;
    height: number | null;
    width: number | null;
    videooh_encoding_status: 'encoding' | 'error' | 'done' | null;
    videooh_media: string | null;
    is_draft: boolean;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/media/{id}/fill/url',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that create a creative for a particular media
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiMediaCreative(
    id: number,
    requestBody: {
      id?: number;
      media_id: number;
      mime_type?: string | null;
      name?: string | null;
      path?: string | null;
      created_at?: string | null;
    },
  ): CancelablePromise<{
    id: number;
    media_id: number;
    mime_type: string | null;
    name: string | null;
    path: string | null;
    created_at: string | null;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/media/{id}/creative',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns a list of creatives for a media
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiMediaCreativeList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    media_id: number;
    mime_type: string | null;
    name: string | null;
    path: string | null;
    created_at: string | null;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{id}/creative/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that upload a creative for a particular media
   * @param id
   * @param formData
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiMediaCreativeUpload(
    id: number,
    formData: {
      file: Blob;
    },
  ): CancelablePromise<{
    id: number;
    media_id: number;
    mime_type: string | null;
    name: string | null;
    path: string | null;
    created_at: string | null;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/media/{id}/creative/upload',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * Method that download a particular media
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiMediaDownload(
    id: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{id}/download',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that download a particular media preview
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiMediaDownloadPreview(
    id: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{id}/download/preview',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns a list of events for a media
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiMediaEventList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    media_id: number;
    event_id: number;
    primary: boolean;
    event_name: string | null;
    url: string | null;
    views: number | null;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{id}/event/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that deletes a media html5 files
   * @param filePath
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiMediaHtml5(
    filePath: string,
    id: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/media/{id}/html5',
      path: {
        'id': id,
      },
      query: {
        'file_path': filePath,
      },
    });
  }

  /**
   * Method that upload a html5 content for a particular media
   * @param id
   * @param formData
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiMediaHtml5(
    id: number,
    formData: {
      file: Blob;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/media/{id}/html5',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * Method that uploads a media
   * @param id
   * @param formData
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiMediaUpload(
    id: number,
    formData: {
      file: Blob;
    },
  ): CancelablePromise<{
    id: number;
    name: string | null;
    content_type_id: number;
    media_type_id: number;
    format_id: number | null;
    mime_type: string | null;
    preview_image_path: string | null;
    media: string | null;
    headline: string | null;
    display_url: string | null;
    duration: number | null;
    created_at: string | null;
    is_replacement: boolean;
    is_deleted: boolean;
    is_secure: boolean;
    owner_id: number | null;
    agency_id: number | null;
    platform_id: number;
    filesize: number | null;
    height: number | null;
    width: number | null;
    videooh_encoding_status: 'encoding' | 'error' | 'done' | null;
    videooh_media: string | null;
    is_draft: boolean;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/media/{id}/upload',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * Method that uploads a media image preview
   * @param id
   * @param formData
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiMediaUploadPreview(
    id: number,
    formData: {
      file: Blob;
    },
  ): CancelablePromise<{
    id: number;
    name: string | null;
    content_type_id: number;
    media_type_id: number;
    format_id: number | null;
    mime_type: string | null;
    preview_image_path: string | null;
    media: string | null;
    headline: string | null;
    display_url: string | null;
    duration: number | null;
    created_at: string | null;
    is_replacement: boolean;
    is_deleted: boolean;
    is_secure: boolean;
    owner_id: number | null;
    agency_id: number | null;
    platform_id: number;
    filesize: number | null;
    height: number | null;
    width: number | null;
    videooh_encoding_status: 'encoding' | 'error' | 'done' | null;
    videooh_media: string | null;
    is_draft: boolean;
  } | null> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/media/{id}/upload/preview',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * Method that returns a list of videos for a media
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiMediaVideoList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    media_id: number;
    mime_type: string;
    file_path: string;
    duration: number | null;
    width: number;
    height: number;
    bitrate: number | null;
    filesize: number | null;
    created_at: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{id}/video/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that deletes a media attribute
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiMediaAttribute(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    media_id: number;
    type_id: number;
    value: string | null;
    created_at: string | null;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/media/{id1}/attribute/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that returns a particular media attribute
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiMediaAttribute(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    media_id: number;
    type_id: number;
    value: string | null;
    created_at: string | null;
    attribute_type?: {
      id?: number;
      content_type_id: number;
      value_type?: 'path' | 'string' | 'integer' | 'float' | 'boolean' | 'text' | null;
      name?: string;
      default_value?: string | null;
      mandatory?: boolean;
    };
    url?: string;
  } | null> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{id1}/attribute/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that uploads a media attribute file
   * @param id1
   * @param id2
   * @param formData
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiMediaAttributeUpload(
    id1: number,
    id2: number,
    formData: {
      file: Blob;
    },
  ): CancelablePromise<{
    id: number;
    media_id: number;
    type_id: number;
    value: string | null;
    created_at: string | null;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/media/{id1}/attribute/{id2}/upload',
      path: {
        'id1': id1,
        'id2': id2,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * Method that deletes a creative for a media
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiMediaCreative(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    media_id: number;
    mime_type: string | null;
    name: string | null;
    path: string | null;
    created_at: string | null;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/media/{id1}/creative/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that returns a particular media creative
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiMediaCreative(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    media_id: number;
    mime_type: string | null;
    name: string | null;
    path: string | null;
    created_at: string | null;
  } | null> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{id1}/creative/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that download a particular media creative
   * @param id1
   * @param id2
   * @param adstandingSessionId
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiMediaCreativeDownload(
    id1: number,
    id2: number,
    adstandingSessionId?: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{id1}/creative/{id2}/download',
      path: {
        'id1': id1,
        'id2': id2,
      },
      query: {
        'adstanding_session_id': adstandingSessionId,
      },
    });
  }

  /**
   * Method that deletes an event for a particular media
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiMediaEvent(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    media_id: number;
    event_id: number;
    primary: boolean;
    event_name: string | null;
    url: string | null;
    views: number | null;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/media/{id1}/event/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that returns a particular media event
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiMediaEvent(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    media_id: number;
    event_id: number;
    primary: boolean;
    event_name: string | null;
    url: string | null;
    views: number | null;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{id1}/event/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that deletes a video for a media
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiMediaVideo(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    media_id: number;
    mime_type: string;
    file_path: string;
    duration: number | null;
    width: number;
    height: number;
    bitrate: number | null;
    filesize: number | null;
    created_at: string;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/media/{id1}/video/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that returns a particular media video
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiMediaVideo(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    media_id: number;
    mime_type: string;
    file_path: string;
    duration: number | null;
    width: number;
    height: number;
    bitrate: number | null;
    filesize: number | null;
    created_at: string;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{id1}/video/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that download a particular video
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiMediaVideoDownload(
    id1: number,
    id2: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{id1}/video/{id2}/download',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that upload a video for a particular media
   * @param id1
   * @param id2
   * @param formData
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiMediaVideoUpload(
    id1: number,
    id2: number,
    formData: {
      file: Blob;
    },
  ): CancelablePromise<{
    id: number;
    media_id: number;
    mime_type: string;
    file_path: string;
    duration: number | null;
    width: number;
    height: number;
    bitrate: number | null;
    filesize: number | null;
    created_at: string;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/media/{id1}/video/{id2}/upload',
      path: {
        'id1': id1,
        'id2': id2,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * Method that creates a media attribute
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiMediaAttribute(
    requestBody: {
      id?: number;
      media_id: number;
      type_id: number;
      value?: string | null;
      created_at?: string | null;
    },
  ): CancelablePromise<{
    id: number;
    media_id: number;
    type_id: number;
    value: string | null;
    created_at: string | null;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/media/attribute',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns a list of media attribute types
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiMediaAttributeTypeList(): CancelablePromise<Array<{
    id: number;
    content_type_id: number;
    value_type: 'path' | 'string' | 'integer' | 'float' | 'boolean' | 'text' | null;
    name: string;
    default_value: string | null;
    mandatory: boolean;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/attribute/type/list',
    });
  }

  /**
   * Method that deletes selected media
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiMediaBatch(
    requestBody: {
      id: Array<number>;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/media/batch',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates a creative for a particular media
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiMediaCreative(
    id: string,
    requestBody: {
      id: number;
      media_id?: number;
      mime_type?: string | null;
      name?: string | null;
      path?: string | null;
      created_at?: string | null;
    },
  ): CancelablePromise<{
    id: number;
    media_id: number;
    mime_type: string | null;
    name: string | null;
    path: string | null;
    created_at: string | null;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/media/creative/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that creates an event for a particular media
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiMediaEvent(
    requestBody: {
      id?: number;
      media_id: number;
      event_id: number;
      primary?: boolean;
      event_name?: string | null;
      url?: string | null;
      views?: number | null;
    },
  ): CancelablePromise<{
    id: number;
    media_id: number;
    event_id: number;
    primary: boolean;
    event_name: string | null;
    url: string | null;
    views: number | null;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/media/event',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates an event for a particular media
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiMediaEvent(
    requestBody: {
      id: number;
      media_id: number;
      event_id?: number;
      primary?: boolean;
      event_name?: string | null;
      url?: string | null;
      views?: number | null;
    },
  ): CancelablePromise<{
    id: number;
    media_id: number;
    event_id: number;
    primary: boolean;
    event_name: string | null;
    url: string | null;
    views: number | null;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/media/event',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns a list of media
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param id
   * @param campaignId
   * @param name
   * @param createdAt
   * @param formatId
   * @param contentTypeId
   * @param mediaTypeId
   * @param agencyId
   * @param isDeleted
   * @param isDraft
   * @param filesize
   * @param width
   * @param height
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiMediaList(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    id?: Array<number>,
    campaignId?: number,
    name?: string,
    createdAt?: string,
    formatId?: number,
    contentTypeId?: Array<number>,
    mediaTypeId?: number,
    agencyId?: number,
    isDeleted: boolean = false,
    isDraft?: boolean,
    filesize?: number,
    width?: number,
    height?: number,
  ): CancelablePromise<Array<{
    id: number;
    name: string | null;
    content_type_id: number;
    media_type_id: number;
    format_id: number | null;
    mime_type: string | null;
    preview_image_path: string | null;
    media: string | null;
    headline: string | null;
    display_url: string | null;
    duration: number | null;
    created_at: string | null;
    is_replacement: boolean;
    is_deleted: boolean;
    is_secure: boolean;
    owner_id: number | null;
    agency_id: number | null;
    platform_id: number;
    filesize: number | null;
    height: number | null;
    width: number | null;
    videooh_encoding_status: 'encoding' | 'error' | 'done' | null;
    videooh_media: string | null;
    is_draft: boolean;
    media_event?: Array<{
      id?: number;
      media_id: number;
      event_id: number;
      primary?: boolean;
      event_name?: string | null;
      url?: string | null;
      views?: number | null;
    }>;
    campaign_media?: Array<{
      id?: number;
      campaign_id: number;
      media_id: number;
      parent_campaign_media_id?: number | null;
      is_companion?: boolean;
      approval_status_id?: 'active' | 'inactive' | 'pending' | 'refused';
      views?: number;
      clicks?: number;
      viewed_impressions?: number;
      refreshed_impressions?: number;
      undetermined_impressions?: number;
      created_at?: string;
      zone_id?: number | null;
      clickthrough_url?: string | null;
      start_date?: string | null;
      end_date?: string | null;
      max_impressions_ratio?: number;
      is_video_playing_out_of_view?: boolean;
      is_video_looping?: boolean;
      inline_pause_to_overlay?: boolean;
      refusal_notes?: string | null;
    }>;
    media_video?: Array<{
      id?: number;
      media_id: number;
      mime_type: string;
      file_path: string;
      duration?: number | null;
      width: number;
      height: number;
      bitrate?: number | null;
      filesize?: number | null;
      created_at?: string;
    }>;
    media_creative?: Array<{
      id?: number;
      media_id: number;
      mime_type?: string | null;
      name?: string | null;
      path?: string | null;
      created_at?: string | null;
    }>;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/list',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'id': id,
        'campaign_id': campaignId,
        'name': name,
        'created_at': createdAt,
        'format_id': formatId,
        'content_type_id': contentTypeId,
        'media_type_id': mediaTypeId,
        'agency_id': agencyId,
        'is_deleted': isDeleted,
        'is_draft': isDraft,
        'filesize': filesize,
        'width': width,
        'height': height,
      },
    });
  }

  /**
   * Method that returns the media count
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param id
   * @param campaignId
   * @param name
   * @param createdAt
   * @param formatId
   * @param contentTypeId
   * @param mediaTypeId
   * @param agencyId
   * @param isDeleted
   * @param isDraft
   * @param filesize
   * @param width
   * @param height
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiMediaListCount(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    id?: Array<number>,
    campaignId?: number,
    name?: string,
    createdAt?: string,
    formatId?: number,
    contentTypeId?: Array<number>,
    mediaTypeId?: number,
    agencyId?: number,
    isDeleted: boolean = false,
    isDraft?: boolean,
    filesize?: number,
    width?: number,
    height?: number,
  ): CancelablePromise<{
    count: number;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/list/count',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'id': id,
        'campaign_id': campaignId,
        'name': name,
        'created_at': createdAt,
        'format_id': formatId,
        'content_type_id': contentTypeId,
        'media_type_id': mediaTypeId,
        'agency_id': agencyId,
        'is_deleted': isDeleted,
        'is_draft': isDraft,
        'filesize': filesize,
        'width': width,
        'height': height,
      },
    });
  }

  /**
   * Method that returns a list of media types
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiMediaTypeList(): CancelablePromise<Array<{
    id: number;
    type: 'banner' | 'background' | 'video' | 'catfish' | 'in_image' | 'splash' | 'digital_billboard' | 'audio';
    active: boolean;
    is_public: boolean;
    is_advanced: boolean;
    is_formatted: boolean;
    content_type: Array<{
      id: number;
      content_type: 'text' | 'image' | 'flash' | 'external' | 'script' | 'video' | 'external_image' | 'external_vast' | 'html5' | 'audio' | 'external_daast' | 'native';
      allowed_for_site: boolean;
      allowed_for_network: boolean;
      allowed_for_background: boolean;
      available: boolean;
      is_public: boolean;
      is_formatted: boolean;
    }>;
    zone_type_id: Array<number>;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/type/list',
    });
  }

  /**
   * Method that creates video for a particular media
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiMediaVideo(
    requestBody: {
      id?: number;
      media_id: number;
      mime_type: string;
      file_path: string;
      duration?: number | null;
      width: number;
      height: number;
      bitrate?: number | null;
      filesize?: number | null;
      created_at?: string;
    },
  ): CancelablePromise<{
    id: number;
    media_id: number;
    mime_type: string;
    file_path: string;
    duration: number | null;
    width: number;
    height: number;
    bitrate: number | null;
    filesize: number | null;
    created_at: string;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/media/video',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates a video for a particular media
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiMediaVideo(
    requestBody: {
      id: number;
      media_id?: number;
      mime_type?: string;
      file_path?: string;
      duration?: number | null;
      width?: number;
      height?: number;
      bitrate?: number | null;
      filesize?: number | null;
      created_at?: string;
    },
  ): CancelablePromise<{
    id: number;
    media_id: number;
    mime_type: string;
    file_path: string;
    duration: number | null;
    width: number;
    height: number;
    bitrate: number | null;
    filesize: number | null;
    created_at: string;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/media/video',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

}
